import React from "react";
// reactstrap components
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Row,
	Col,
} from "reactstrap";
import moment from 'moment';
import { Link } from "react-router-dom";

// Requests
import { getPaymentRequest } from '../../api/payment';
// Helpers
import { formatPaymentType, formatPaymentSubtype } from "helpers/payment";
import { formatPaymentStatus } from "helpers/status";
// Components
import History from "components/History/History";

class PaymentDetails extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			payment: null,
			logs: null,
			addingEntry: false,
			newEntryText: "",
			saving: false
		}
	}

	async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');

		if (id) {
			const payment = await getPaymentRequest(id);
            this.setState({ 
              payment,
            })
		} else {
			this.goTo('/payments')
		}
	}

	goTo = path => this.props.history.push(path);


	render() {

		const {
			payment = {},
		} = this.state;

		const {
			_id,
			type,
			subtype,
			amount,
			loan_interest,
			extras,
			extras_description,
			total,
			is_inbound,
			status,
			client,
			seller,
			due_date,
			settled_date,
			sales_invoice,
			acknowledgement_receipt,
			check_number,
			bank_name,
			payment_method,
        	si_number,
			is_ar,
			created_at,
			updated_at
		} = payment || {};

		return (
			<>
				<div className="content">
					<Row>
						<Col md="12">
							<Card>
								<CardHeader className="mb-5">
									<CardTitle tag="h3">
										Payment Details
                  					</CardTitle>
									<Button
										className="float-right"
										color="default"
										onClick={() => this.goTo('/payments')}
									>
										Back
                  					</Button>
								</CardHeader>
								<CardBody>
									{!payment
										? <div>Loading...</div>
										: <>
											<div className="typography-line">
												<h4>
													<span>ID</span>
													{_id}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Type</span>
													{type ? formatPaymentType(type) : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Subtype</span>
													{subtype ? formatPaymentSubtype(subtype) : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Amount</span>
													{amount ? <>
															<div className={is_inbound ? 'text-success' : 'text-danger'}>{is_inbound ? '+' : '-'} {`PHP ${amount}`}</div>
														</> : "N/A"
													}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Loan Interest</span>
													{loan_interest ? <>
															<div className={is_inbound ? 'text-success' : 'text-danger'}>{is_inbound ? '+' : '-'} {`PHP ${loan_interest}`}</div>
														</> : "N/A"
													}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Extras</span>
													{extras ? <>
															<div className={is_inbound ? 'text-success' : 'text-danger'}>{is_inbound ? '+' : '-'} {`PHP ${extras}`}</div>
														</> : "N/A"
													}
												</h4>
											</div>
											{!!extras ? <div className="typography-line">
												<h4>
													<span>Extras: Description</span>
													{extras_description || "N/A"}
												</h4>
											</div> : null}
											<div className="typography-line">
												<h4>
													<span>Total</span>
													{total ? <>
															<div className={is_inbound ? 'text-success' : 'text-danger'}>{is_inbound ? '+' : '-'} {`PHP ${total}`}</div>
														</> : "N/A"
													}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Payment Method</span>
													{payment_method || "N/A"}
												</h4>
											</div>	
											<div className="typography-line">
												<h4>
													<span>Check #</span>
													{check_number || "N/A"}
												</h4>
											</div>

											{!!check_number ? <div className="typography-line">
												<h4>
													<span>Bank Name</span>
													{bank_name || "N/A"}
												</h4>
											</div> : null}

											<div className="typography-line">
												<h4>
													<span>{is_ar ? "AR #" : "SI #"}</span>
													{si_number || "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Status</span>
													{status ? formatPaymentStatus(status) : "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Client</span>
													{client ? 
														<Link to={`/client?id=${client._id}`}>
															{`${client.first_name} ${client.last_name}`}
														</Link>
													:
														"N/A"
													}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Seller</span>
													{seller ? 
														<Link to={`/seller?id=${seller._id}`}>
															{`${seller.first_name} ${seller.last_name}`}
														</Link>
													:
														"N/A"
													}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Due Date</span>
													{due_date ? moment(due_date).format("MM/DD/YYYY") : "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Settled Date</span>
													{settled_date ? moment(settled_date).format("MM/DD/YYYY") : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Sale Invoice</span>
													{ sales_invoice ? <a target="_blank" rel="noopener noreferrer" href={sales_invoice}>{sales_invoice}</a> : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Acknowledgement Receipt</span>
													{ acknowledgement_receipt ? <a target="_blank" rel="noopener noreferrer" href={acknowledgement_receipt}>{acknowledgement_receipt}</a> : "N/A"}												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Created At</span>
													{created_at ? moment(created_at).format("YYYY-MM-DD HH:mm:ss") : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Updated At</span>
													{updated_at ? moment(updated_at).format("YYYY-MM-DD HH:mm:ss") : "N/A"}
												</h4>
											</div>
										</>
									}
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Row>
						<Col md="12">
							<History location={this.props.location} component={payment} type="payment"/>
						</Col>
					</Row>
				</div>
			</>
		);
	}
}

export default PaymentDetails;
